module.exports = __webpack_public_path__ + "img/chris_g_39.13087c99.jpg";